import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function TrackingSection() {
  const tracked = [...comics].sort((a, b) => b.hot - a.hot).slice(0, 4);

  return (
    <section id="tracking" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-primary-600">
            <span className="inline-block h-2 w-2 rounded-full bg-primary-500"></span>追更进度
          </p>
          <h2 className="font-heading mt-3 text-2xl text-foreground-950 md:text-4xl">
            追更进度一目了然
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
            每一部连载的同步更新进度与汉化进度实时呈现，抢先看最新话，不再错过任何一次更新。
          </p>
        </div>
        <Link
          to="/rank"
          className="flex items-center whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700"
        >
          查看追更榜 <i className="ri-arrow-right-line ml-1"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {tracked.map((c) => (
          <Link
            key={c.id}
            to={`/comic/${c.id}`}
            className="group rounded-lg border border-background-200 bg-background-50 p-4 transition-all hover:-translate-y-1"
          >
            <div className="flex items-center gap-3">
              <img
                src={c.cover}
                alt={`${c.title} 漫画封面`}
                title={`${c.title} 追更进度`}
                className="h-20 w-14 rounded-md object-cover object-top"
              />
              <div className="min-w-0">
                <h3 className="truncate text-sm font-bold text-foreground-950">{c.title}</h3>
                <p className="mt-1 flex items-center gap-1 text-xs text-secondary-700">
                  <i className="ri-check-double-line"></i>
                  更新至 {c.latestChapter.split('·')[0].trim()}
                </p>
                <p className="mt-1 truncate text-xs text-foreground-500">
                  {c.categories.join(' / ')}
                </p>
              </div>
            </div>

            <div className="mt-4 space-y-2.5">
              <div>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-foreground-600">同步更新进度</span>
                  <span className="font-bold text-secondary-700">{c.updateProgress}%</span>
                </div>
                <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className="h-full rounded-full bg-secondary-500" style={{ width: `${c.updateProgress}%` }}></div>
                </div>
              </div>
              <div>
                <div className="flex items-center justify-between text-xs">
                  <span className="text-foreground-600">汉化进度</span>
                  <span className="font-bold text-primary-700">{c.translateProgress}%</span>
                </div>
                <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                  <div className="h-full rounded-full bg-primary-500" style={{ width: `${c.translateProgress}%` }}></div>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}